import { ArrowUpFromLine } from "lucide-react";
import {
  gql,
  InternalOutboundLogOrderByColumn,
  InternalOutboundLogsFilterField,
} from "types";
import { FieldType, InternalResourceConfig } from "../lib/internal-resources";

const GET_OUTBOUND_LOG_LIST = gql(/* GraphQL */ `
  query InternalOutboundLogList(
    $pagination: Pagination
    $filters: InternalOutboundLogsFiltersExpression
    $orderBy: InternalOutboundLogOrderByInput
  ) {
    internalOutboundLogList(
      pagination: $pagination
      filters: $filters
      orderBy: $orderBy
    ) {
      count
      list {
        id
        connector
        status
        endpoint
        destination
        entityType
        entityId
        outboundId
        retryCount
        error
        data
        response
        createdAt
      }
    }
  }
`);

export const outboundLogResourceConfig: InternalResourceConfig = {
  resourceName: "outbound-log",
  displayNameKey: "apps.admin.internalResources.outboundLog.title",
  basePath: "/internal/data/outbound-log",

  listQuery: GET_OUTBOUND_LOG_LIST,
  listQueryName: "internalOutboundLogList",

  fields: [
    {
      key: "connector",
      labelKey: "apps.admin.internalResources.outboundLog.columns.connector",
      type: FieldType.String,
      sortKey: InternalOutboundLogOrderByColumn.Connector,
      width: 120,
    },
    {
      key: "status",
      labelKey: "apps.admin.internalResources.outboundLog.columns.status",
      type: FieldType.Enum,
      sortKey: InternalOutboundLogOrderByColumn.Status,
      width: 120,
      enumValues: {
        Pending: { label: "Pending", color: "yellow" },
        Failed: { label: "Failed", color: "red" },
        Success: { label: "Success", color: "green" },
      },
    },
    {
      key: "endpoint",
      labelKey: "apps.admin.internalResources.outboundLog.columns.endpoint",
      type: FieldType.String,
      sortKey: InternalOutboundLogOrderByColumn.Endpoint,
      width: 100,
    },
    {
      key: "destination",
      labelKey: "apps.admin.internalResources.outboundLog.columns.destination",
      type: FieldType.String,
      width: 300,
    },
    {
      key: "entityType",
      labelKey: "apps.admin.internalResources.outboundLog.columns.entityType",
      type: FieldType.String,
      sortKey: InternalOutboundLogOrderByColumn.EntityType,
      width: 150,
    },
    {
      key: "entityId",
      labelKey: "apps.admin.internalResources.outboundLog.columns.entityId",
      type: FieldType.Uuid,
      width: 150,
    },
    {
      key: "retryCount",
      labelKey: "apps.admin.internalResources.outboundLog.columns.retryCount",
      type: FieldType.String,
      width: 100,
    },
    {
      key: "error",
      labelKey: "apps.admin.internalResources.outboundLog.columns.error",
      type: FieldType.String,
      width: 200,
    },
    {
      key: "data",
      labelKey: "apps.admin.internalResources.outboundLog.columns.data",
      type: FieldType.JSON,
      width: { min: 100, grow: 1 },
    },
    {
      key: "response",
      labelKey: "apps.admin.internalResources.outboundLog.columns.response",
      type: FieldType.JSON,
      width: { min: 100, grow: 1 },
    },
    {
      key: "createdAt",
      labelKey: "apps.admin.internalResources.outboundLog.columns.createdAt",
      type: FieldType.DateTime,
      sortKey: InternalOutboundLogOrderByColumn.CreatedAt,
      width: 160,
    },
  ],

  list: {
    defaultSort: {
      column: InternalOutboundLogOrderByColumn.CreatedAt,
      direction: "desc",
    },
    searchFields: [
      InternalOutboundLogsFilterField.Connector,
      InternalOutboundLogsFilterField.Status,
      InternalOutboundLogsFilterField.Url,
      InternalOutboundLogsFilterField.EntityType,
    ],
  },

  navigation: {
    icon: <ArrowUpFromLine size={16} />,
    order: 7,
  },
};
